
import {React, useState, useContext, useEffect, useRef} from "react"
import {useStyle} from '../../context/styleContext/styleContext'
import ReactGA from 'react-ga4';
import { Paper } from '@mui/material';
import { Container, Typography, Divider, Box, List, ListItem, ListItemText } from "@mui/material";


export default function DelayLearning(){

  const { style, setStyle } = useStyle();
  const [width, setWidth] = useState(window.innerWidth)

function handleWindowSizeChange() {
    setWidth(window.innerWidth);
}
useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
}, []);

const isMobile = width <= 768;

useEffect(() => {
  document.title = 'Parish Audio | Cutting-Edge Audio Processing | Delay';
}, []);

ReactGA.send({
    hitType:"pageview",
    page:"learning/delay",
    title:"learning/delay",
  })

  const [height, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })

const topContainer = useRef();
    useEffect(() => {
        // To make sure page starts from the top
        topContainer.current.scrollIntoView({ block: "end" });
    }, []);




    return(
        <>
        <div style={{display:'flex', backgroundImage: `url("/RecordingStudioStockImage1.jpg")`, backgroundSize: "cover", backgroundPosition: "center", marginBottom:'0px', flex:1, minHeight:height-130, color:style.color4, padding:'0px'}}>
        <div style={{display:'flex', flex:1}}>

        <div className="dark-alpha-80" style={{flex:1}}>
<div style={{width:'95%', maxWidth:'1000px', margin:'auto'}}>



        <h1 ref={topContainer} style={{marginTop:'20px'}}>Delay</h1>

        <Divider className="mobile-card-divider" />
      <p variant="body1" sx={{ color: "#dddddd", fontSize: "1.1rem" }}>
        Delay is an effect that sounds similar to an echo. This is achieved by storing a copy of the signal and playing it back act
        a later time, blended in with the current signal. 
      </p>
      <h2 style={{marginTop:'25px', marginBottom:'0px'}}>History</h2>
      <p>Delay was first used by Radio broadcasters in the 1930s, using a telephone line. The audio signal was sent over the phone line to 
        a town located several hunderd miles away, and then was sent back to studio. This created a delay in the return signal
        of a few milliseconds, and the delayed signal could then be mixed back in<sup><a href="#cite1">[1]</a></sup>.

      </p>
      <p>The 1950's saw the rise of Reel to Reel tape delays, which were made from a loop of magnetic tape played over a reel to reel system. The input signal would be recorded 
        to the tape, and the length of the tape loop as well as the position of the heads could be adjusted to change the delay time, volume, and other parameters. The sound 
        that was recorded on the tape would then be played back at the desired time and mixed back into the signal.
      </p>

      <p>Digital delay first became available in 1971 with the <a href='https://www.eventideaudio.com/' target="_blank" rel="noopener noreferrer"><strong>Eventide</strong></a> DDL 1745. The first digital Delay effects were extremely
      expensive, with the DDL 1745 retailing for $4000 ($28,000 adjusted for inflation)<sup><a href="#cite2">[2]</a></sup>. Digital delay offers extreme precision and flexibility, and has become the most popular
      type of delay in use today.</p>
      <h2 style={{marginTop:'30px'}}>Types</h2>
      <div style={{padding:'0px', marginTop:'20px'}}>
        <h3 style={{marginTop:'0px', marginBottom:'10px'}}>
                Ping Pong Delay
        </h3>
        <p style={{marginBottom:'10px', marginTop:'0px'}}>
        A ping-pong delay causes the delayed signal to alternate between the left and right channels. This can help widen the stereo imaging of your track while also enhancing depth and movement.
        </p>

      </div>
      <div>
      <h3 style={{marginTop:'20px', marginBottom:'10px'}}>
          Tape Delay
      </h3>
      <p style={{marginBottom:'10px', marginTop:'0px'}}>
      First becoming available in the 1950's, a tape delay works by recording an incoming audio signal onto a loop of magnetic tape, then playing it back a short time later. The delay time can be adjusted by changing the distance between the read and write heads, or by changing the speed of the tape.  is determined by the distance between the record and playback heads and the speed at which the tape moves. Magnetic tape naturally introduces slight variations in speed (wow and flutter) and subtle saturation, the effect has a warm, organic character.
      </p>
      </div>
      <div>
      <h3 style={{marginTop:'20px', marginBottom:'10px'}}>
            Multi Tap Delay
      </h3>
      <p style={{marginBottom:'15px', marginTop:'0px'}}>
            Multi Tap delay allows the user to use multiple delays and adjust the timing and settings separately. This allows the
            creation of complex rhythms and patterns.
      </p>
      </div>
      <div>
      <h3 style={{marginTop:'20px', marginBottom:'10px'}}>
            Digital Delay
      </h3>
      <p style={{marginBottom:'15px', marginTop:'0px'}}>
      A digital delay records the input signal digitally, stores it in memory, and then plays it back after a set time, mixed in with the current signal. Introduced in 1971, digital delays are known for their flexability and accuracy.
      </p>
      </div>
      
    
      <Divider className="mobile-card-divider" />
      <div style={{marginBottom:'25px', marginTop:'50px'}}>
      <h2>References</h2>
      <p id="cite1"> <a href="https://soundbetter.com/kb/delay-a-history-analysis" target="_blank" rel="noopener noreferrer">[1] Fectoper, B. (n.d.). <i>Delay: A History & Analysis</i>. SoundBetter. https://soundbetter.com/kb/delay-a-history-analysis</a></p>
      <p id="cite2">[2] <a href="https://www.eventideaudio.com/50th-flashback-2-1-the-ddl-1745-delay/" target="_blank" rel="noopener noreferrer">AAgnello. (2023, June 8). <i>50th Flashback #2.1: The DDL 1745 Delay</i>. Eventide Audio.</a></p>


      </div>

      </div>
</div>
  </div>
</div>



        
        </>

    )
}